import React from 'react';
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
import DownloadBox from './DownloadBox';
import { ToolItem } from '../../typings/home';

interface ToolsSectionProps {
  title?: string;
  tools: ToolItem[];
}

export const ToolsSection: React.FC<ToolsSectionProps> = ({ 
  title = "Additional tools", 
  tools 
}) => {
  return (
    <DHBox sx={{ 
      // Digital HIG responsive dimensions
      height: 'auto',
      width: { xs: '100%', sm: '100%', md: '100%', lg: '360px', xl: '360px' },
      display: 'flex', 
      flexDirection: 'column', 
      gap: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
      // Digital HIG breakpoint for 1320px
      '@media (min-width: 1320px)': {
        width: '360px',
        gap: 2
      },
      '@media (max-width: 1319px)': {
        width: '100%',
        gap: { xs: '12px', sm: '16px', md: '16px' }
      }
    }}>
      {/* Tools Title */}
      <DHBox sx={{ 
        textAlign: 'left', 
        width: { xs: '100%', sm: '100%', md: '100%', lg: '360px', xl: '360px' },
        height: { xs: 'auto', sm: 'auto', md: 'auto', lg: '26px', xl: '26px' }
      }}>
        <DHTypography 
          variant="headline-small" 
          component="h3" 
          gutterBottom 
          sx={{
            fontFamily: 'Artifakt Element',
            fontWeight: 700,
            fontSize: { xs: '18px', sm: '20px', md: '21px', lg: '21px', xl: '21px' },
            lineHeight: '125%',
            letterSpacing: '0%'
          }}
        >
          {title} ({tools.length})
        </DHTypography>
      </DHBox>

      {/* Tools List */}
      {tools.map((tool) => (
        <DownloadBox
          key={tool.id}
          heading={tool.heading}
          text={tool.text}
          buttonText={tool.buttonText}
          buttonLink={tool.buttonLink}
          buttonVariant={tool.buttonVariant}
          onButtonClick={tool.onButtonClick}
        />
      ))}
    </DHBox>
  );
};

